import React, { useEffect } from "react";
import "./clutch.css";

export default function ClutchWizard() {
  const COMPANY_ID = "2155858";
  const widgetUrl = `https://widget.clutch.co/widgets/get/17?ref_domain=${window.location.hostname}&uid=${COMPANY_ID}`;

  useEffect(() => {
    const loadWidget = () => {
      if (window.ClutchWidget) {
        try {
          window.ClutchWidget.load();
        } catch (error) {
          console.error("Clutch Widget load error:", error);
        }
        return;
      }

      const script = document.createElement("script");
      script.src = "https://widget.clutch.co/static/js/widget.js";
      script.async = true;
      script.onload = () => {
        try {
          if (window.ClutchWidget) {
            window.ClutchWidget.load();
            return;
          }
          const checkInterval = setInterval(() => {
            if (window.ClutchWidget) {
              try {
                window.ClutchWidget.load();
                clearInterval(checkInterval);
              } catch (error) {
                console.error("Clutch Widget interval load error:", error);
                clearInterval(checkInterval);
              }
            }
          }, 100);
        } catch (error) {
          console.error("Clutch Widget onload error:", error);
        }
      };

      script.onerror = () => {
        console.error("Failed to load Clutch widget script");
      };

      document.body.appendChild(script);
      return () => {
        document.body.removeChild(script);
      };
    };

    loadWidget();
  }, []);

  return (
    <div className="clutch-widget-container">
      <iframe
        src={widgetUrl}
        title="Clutch Reviews"
        width="100%"
        height="100"
        frameBorder="0"
        scrolling="no"
        className="clutch-iframe"
        loading="lazy"
      />
    </div>
  );
}
